var BASE = process.env.PUBLIC_URL || '';
var GRAB_CURSOR = 'url("' + BASE + '/cursors/grab.svg") 9 11, grab';
var GRABBING_CURSOR = 'url("' + BASE + '/cursors/grabbing.svg") 9 10, grabbing';

var STYLE_ID = 'metatip-cursor-fix';
var STYLE_CSS =
  '.userInput{cursor:' + GRAB_CURSOR + '!important}' +
  '.userInput:active{cursor:' + GRABBING_CURSOR + '!important}';

function patchModelViewer(mv) {
  var sr = mv.shadowRoot;
  if (!sr) return;
  if (sr.getElementById(STYLE_ID)) return;

  var style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = STYLE_CSS;
  sr.appendChild(style);
}

function scan() {
  document.querySelectorAll('model-viewer').forEach(function (mv) {
    patchModelViewer(mv);
  });
}

scan();

var observer = new MutationObserver(scan);
observer.observe(document.documentElement, { childList: true, subtree: true });

var n = 0;
var retryInterval = setInterval(function () {
  scan();
  if (++n >= 30) clearInterval(retryInterval);
}, 300);
